export const updatePrice = (price) => {
    window.price = price;

    if (!window.servObj?.calc || !Array.isArray(price)) return;

    price.forEach((item) => {
        if (!item.id) return;

        // Берём все ключи, которые равны item.id или начинаются с item.id + "__"
        const keys = Object.keys(window.servObj.calc).filter(
            (key) => key === item.id || key.startsWith(item.id + "__"),
        );

        if (keys.length) {
            keys.forEach((key) => {
                const obj = window.servObj.calc[key];
                obj.price = item.price ?? 0;
                obj.price_esd = item.price_esd ?? 0;
            });
        } else {
            // console.warn(`[updatePrice] Не найдено совпадений для прайса id="${item.id}"`);
        }
    });
};
